import { Suspense } from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout route — renders the Outlet so child routes (/users/$id) work.
// The actual list lives in users.index.tsx which renders at /users exactly.
export const Route = createFileRoute('/users')({
  component: UsersLayout,
});

function UsersLayout() {
  return (
    <Suspense fallback={<div style={{ padding: 32, color: 'var(--lca-gray-500)', fontSize: 13 }}>Loading…</div>}>
      <Outlet />
    </Suspense>
  );
}
